import { c as _c } from "react/compiler-runtime";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ButtonProps, Button } from './Button';
export const Back: React.FC<ButtonProps> = t0 => {
  const $ = _c(4);
  const {
    onClick
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArrowBackIcon />;
    t2 = {
      padding: "0px 0px 0px 12px",
      minWidth: "0px",
      marginTop: "-5px"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClick) {
    t3 = <Button aria-label="Back" onClick={onClick} startIcon={t1} sx={t2} disableRipple={true} />;
    $[2] = onClick;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};